// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"_2f5Pb","faq":"_19goX","mainContainer":"pcz_j","content":"_23ZBv","container":"_2oOxp"};